import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import heroMainImg from '../assets2/images/hero_woman.png';
//import './frontend.css';


const Hero = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    console.log('Get Started Now clicked');
    navigate('/account');
  };

  const handleLearnMore = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
  <section className="hero__v6 section" id="home">
    <Container>
      <Row>
        <Col lg={6} className="mb-4 mb-lg-0">
          <span className="hero-subtitle text-uppercase">India’s Trusted Billing & Invoicing Software</span>
          <h1 className="hero-title mb-3">
           Simplify GST Billing, Invoicing & eWay Bills

          </h1>
          <p className="hero-description mb-4 mb-lg-5">
           Join thousands of Indian small businesses using HamaraBillBook to manage billing, inventory, e-Invoicing, and more, faster and smarter.

          </p>
          <div className="cta d-flex d-flex-mb  gap-2 mb-4 mb-lg-5">
            <Button variant="primary" onClick={handleGetStarted}>Get Started Now</Button>
            <Button variant="outline-secondary" onClick={handleLearnMore}>Learn More</Button>
          </div>
          <div className="logos mb-4">
            {/*<span className="logos-title text-uppercase mb-4 d-block">
              Trusted by major companies worldwide
            </span>*/}
            {/*<div className="logos-images d-flex gap-4 align-items-center">
              <img className="img-fluid" src={airbnbLogo} alt="Airbnb" style={{ width: 110 }} />
              <img className="img-fluid" src={ibmLogo} alt="IBM" style={{ width: 80 }} />
              <img className="img-fluid" src={googleLogo} alt="Google" style={{ width: 110 }} />

            </div>*/}

<div className="logos-images d-flex gap-4 align-items-center flex-wrap">
  <span className="d-flex align-items-center gap-2">
    <strong>GST Compliant</strong>
  </span>
  <span className="d-flex align-items-center gap-2">
  <strong>Inventory Management</strong>
  </span>
  <span className="d-flex align-items-center gap-2">
     <strong>e-Way Billing</strong>
  </span>
</div>

          </div>
        </Col>

        <Col lg={6}>
          <div className="hero-img position-relative">
                
   <img
  className="img-main img-fluid rounded-4"
  src={heroMainImg}
  alt="Hero"
  style={{
    width: '100%',
    maxWidth: '500px', // limits image width on large screens
    height: 'auto',
    display: 'block',
    margin: '0 auto'
  }}
/>

          </div>
        </Col>
      </Row>
    </Container>
  </section>
  );
};

export default Hero;